export const OrgPlanErrorSection:React.FunctionComponent = () => {
	return (
		<div className="error-info__page">
			<div className="error-info__elements">
				<h1>Something went Wrong!!</h1>
				<p className="error-info__info"> Sorry! We are unable to determine your organisation permissions. Please try again later or refresh the page.</p>
			</div>
		</div>
	);
}